import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

const WatchSourcesForm = React.lazy(
  () => import('components/Scan/WatchSources/Form'),
);

function ScreensWatchSourcesForm() {
  return (
    <BaseLayout>
      <DocumentTitle>Watch Sources</DocumentTitle>
      <Suspense fallback={<UILoader />}>
        <WatchSourcesForm />
      </Suspense>
    </BaseLayout>
  );
}

export default ScreensWatchSourcesForm;
